import {useState} from 'react'
import {Carousel} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Picture} from './Picture.tsx';

interface PicturesInterface {
    pictures: Array<PicturesInterface>;
}

export const Pictures = ({pictures}: PicturesInterface) => {
    const [carouselIndex, setcarouselIndex] = useState<number>(0);

    return (
        <>
            {pictures.length === 1 && <Picture picture={pictures[0]} />}
            {pictures.length > 1 && pictures && (
                <Carousel
                    activeIndex={carouselIndex}
                    onSelect={(selectedIndex) =>
                        setcarouselIndex(selectedIndex)
                    }
                    indicators={false}
                    nextLabel={false}
                    nextIcon={
                        <FontAwesomeIcon
                            size={'2xl'}
                            icon={'angle-right'}
                            color={'black'}
                        />
                    }
                    prevIcon={
                        <FontAwesomeIcon
                            size={'2xl'}
                            icon={'angle-left'}
                            color={'black'}
                        />
                    }
                    prevLabel={false}
                    className={
                        'd-flex justify-content-center align-items-center'
                    }
                    interval={null}
                    fade
                >
                    {pictures.map((picture) => (
                            <Carousel.Item key={picture.piccm_filename}>
                                <Picture picture={picture} />
                            </Carousel.Item>
                        ))}
                </Carousel>
            )}
        </>
    )
}
